import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const EmptyBox = styled.div`
  text-align: center;
  padding: 60px 48px;

  .msg {
    font-size: 16px;
    line-height: 130%;
    color: #999;

    em,
    strong {
      color: #000;
    }
  }

  .btn {
    margin-top: 24px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('60 48')};

    .msg {
      font-size: ${mixin.pxToVw('16')};
    }

    .btn {
      margin-top: ${mixin.pxToVw('24')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 120px 0;

    .msg {
      font-size: 18px;
      line-height: 135%;
    }

    .btn {
      margin-top: 32px;
    }
  }
`;
